import React, { useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Button, Typography } from '@mui/material'

export const CoachDescription = ({ description }: { description: string | null | undefined }) => {
  const styles = useStyles()
  const [isExpanded, setIsExpanded] = useState(false)
  const threshold = 150

  if (!description) {
    return null
  }

  const isLongDescription = description.length > threshold

  return (
    <div className="mt-2">
      <Typography className="text-black">
        {isLongDescription && !isExpanded ? `${description.substring(0, threshold)}...` : description}
      </Typography>
      {isLongDescription && (
        <Button onClick={() => setIsExpanded(!isExpanded)} variant="text" className={styles.readMoreButton}>
          {isExpanded ? 'Read less' : 'Read more'}
        </Button>
      )}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  readMoreButton: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
}))
